import {
  FilterCategoryModel,
  FilterItemModel,
} from "@/models/filterItem.model";
import { KioskModel } from "@/models/kiosk.model";
import Cafe from "@/assets/project-assets/Left-side-menu/Cafés.svg";
import Fashion from "@/assets/project-assets/Left-side-menu/Fashion.svg";
import ATM from "@/assets/project-assets/Left-side-menu/ATM.svg";
import CustomerServiceDesk from "@/assets/project-assets/Left-side-menu/Info.svg";
import BeautyWellness from "@/assets/project-assets/Left-side-menu/Beauty-Wellness.svg";
import BooksStationery from "@/assets/project-assets/Left-side-menu/Books-Stationery.svg";
import Bus from "@/assets/project-assets/Left-side-menu/Bus.svg";
import Desserts from "@/assets/project-assets/Left-side-menu/Confectionary.svg";
import Entrance from "@/assets/project-assets/Left-side-menu/Entrance.svg";
import FastFood from "@/assets/project-assets/Left-side-menu/Fast-food.svg";
import GiftCard from "@/assets/project-assets/Left-side-menu/Gift-cards.svg";
import HomeTech from "@/assets/project-assets/Left-side-menu/Home-Tech.svg";
import Hypermarket from "@/assets/project-assets/Left-side-menu/Hypermarkets.svg";
import JewelleryWatches from "@/assets/project-assets/Left-side-menu/Jewellery-Watches.svg";
import Kids from "@/assets/project-assets/Left-side-menu/Kids-Maternity.svg";
import LostFound from "@/assets/project-assets/Left-side-menu/Box.svg";
import Luxury from "@/assets/project-assets/Left-side-menu/Luxury.svg";
import MallManager from "@/assets/project-assets/Left-side-menu/Manager.svg";
import OpticsEyewear from "@/assets/project-assets/Left-side-menu/Optics-Eyewear.svg";
import PrayerRoomMale from "@/assets/project-assets/Left-side-menu/Prayer-room-male.svg";
import PrayerRoomFemale from "@/assets/project-assets/Left-side-menu/Prayer-room-female.svg";
import RedCrescent from "@/assets/project-assets/Left-side-menu/Charity.svg";
import Restaurant from "@/assets/project-assets/Left-side-menu/Restaurant.svg";
import RestroomFemale from "@/assets/project-assets/Left-side-menu/Female.svg";
import RestroomMale from "@/assets/project-assets/Left-side-menu/Men.svg";
import Services from "@/assets/project-assets/Left-side-menu/Services.svg";
import SpecialtyShop from "@/assets/project-assets/Left-side-menu/Specialty-shop.svg";
import SportsLeisure from "@/assets/project-assets/Left-side-menu/Sports-Leisure.svg";
import Taxi from "@/assets/project-assets/Left-side-menu/Taxi.svg";
import ToysGames from "@/assets/project-assets/Left-side-menu/Toys-Games.svg";
import UberCareem from "@/assets/project-assets/Left-side-menu/Uber.svg";
import ValetParking from "@/assets/project-assets/Left-side-menu/Valet.svg";
import Wifi from "@/assets/wifi.svg";
import Share from "@/assets/project-assets/Left-side-menu/Coin.svg";
import Wheelchair from "@/assets/project-assets/Left-side-menu/Wheelchair.svg";
import BabyChangingFemale from "@/assets/project-assets/Left-side-menu/Female-Baby-Changing.svg";
import BabyChangingMale from "@/assets/project-assets/Left-side-menu/Male-baby-changing.svg";
import ParkingAssist from "@/assets/project-assets/Left-side-menu/Park-assist.svg";
import FirstAid from "@/assets/project-assets/Left-side-menu/First-aid.svg";
import AccessibleParking from "@/assets/accessible-parking.svg";
import FemaleAccessibleToilet from "@/assets/accessible-toilet-F.svg";
import MaleAccessibleToilet from "@/assets/accessible-toilet-M.svg";
import FamilyParking from "@/assets/family-parking.svg";
import Hotel from "@/assets/stay.svg";
import HotelLight from "@/assets/stay-light.svg";
import HotelWhite from "@/assets/project-assets/Left-side-menu/hotel-solid-white.svg";
import Facilities from "@/assets/facilities-ultra.svg";
import FacilitiesWhite from "@/assets/facilities-ultra-white.svg";
import { FaBagShopping, FaFaceSmile, FaUtensils } from "react-icons/fa6";
import { AmenityModel } from "proximiio-js-library/lib/models/amenity";
import Feature from "proximiio-js-library/lib/models/feature";
import Entertainment from "@/assets/entertainment-light.svg";
import iFly from "@/assets/ifly-light.svg";
import LittleExplorers from "@/assets/little-explorers-light.svg";
import MagicPlanet from "@/assets/magic-planet-light.svg";
import Snow from "@/assets/snow-light.svg";
import VoxCinema from "@/assets/vox-cinema-light.svg";

import ElectricScooter from "@/assets/project-assets/electric-scooter-station.svg";
import BikeParking from "@/assets/project-assets/bike-parking.svg";
import ExpectantParking from "@/assets/project-assets/Expectant-mother-parking.svg";
import ElectricCarCharging from "@/assets/project-assets/Electric-car-charging.svg";
import PhoneCharging from "@/assets/phone-charging-light.svg";
import VipPickup from "@/assets/vip-parking.svg";
import BabyCare from "@/assets/baby-feeding-light.svg";
import LowEmissionParking from "@/assets/Low-emission-parking-light.svg";

export const getListAsClosest = () => {
  const closestList = [];
  for (const category of filterCategories) {
    closestList.push(category.items.filter((item) => item.listAsClosest));
  }
  return closestList.flat(2);
};

export const getHiddenItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter((item) => item.hideMapIcon)) {
      list.push(item.id);
    }
  }
  return list.flat(2);
};

export const getExcludedItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter(
      (item) => item.excludeFromSearch,
    )) {
      list.push(item.id);
    }
  }
  return list.flat(2);
};

export const getHiddenUntilSelectedItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter(
      (item) => item.hideIconUntilSelected,
    )) {
      list.push(item.id);
    }
  }
  return list.flat();
};

export const filterCategories: FilterCategoryModel[] = [
  {
    title: "shop",
    id: "shop",
    color: "343,68%,28%",
    icon: FaBagShopping,
    items: [
      {
        title: "fashion",
        iconImage: Fashion,
        id: [
          "a59cce03-e052-4692-bf1d-64b0e9899422:fcbaa40f-a576-49b2-aec1-28919ab9ff15",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "sport-leisure",
        iconImage: SportsLeisure,
        id: [
          "a59cce03-e052-4692-bf1d-64b0e9899422:98a3a912-e453-44e6-84d6-eca19a8dcf7d",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "kids",
        iconImage: Kids,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:e0acc38e-882b-4f15-8f27-624a36719004",
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "home-tech",
        iconImage: HomeTech,
        id: [
          "a59cce03-e052-4692-bf1d-64b0e9899422:8650176b-a01b-496e-ad8e-55043ffbe69a",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "beauty-wellness",
        iconImage: BeautyWellness,
        id: [
          "a59cce03-e052-4692-bf1d-64b0e9899422:f8721eca-cfaf-48da-a7f7-b003a4bc08e4",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "jewellery-watches",
        iconImage: JewelleryWatches,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:7969018e-0a21-4f40-a4ac-6d10dc28d444",
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "books-stationery",
        iconImage: BooksStationery,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:5566c0dd-fc8a-43b2-9b79-805196c26496",
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "toys-games",
        iconImage: ToysGames,
        id: [
          "a59cce03-e052-4692-bf1d-64b0e9899422:e6ea2086-45d5-427b-93d3-86dbd25a4e3e",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "optics-eyewear",
        iconImage: OpticsEyewear,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:93500149-c01b-42a0-b93c-a9d5e1fc776e",
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "speciality",
        iconImage: SpecialtyShop,
        id: [
          "a59cce03-e052-4692-bf1d-64b0e9899422:4354ba66-8597-4eb2-a4a1-d69d9cdd4023",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "luxury",
        iconImage: Luxury,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:0a8adb65-36a1-4a39-ad7d-721f323db63a",
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "hypermarket",
        iconImage: Hypermarket,
        id: [
          "a59cce03-e052-4692-bf1d-64b0e9899422:656af22e-3e37-437c-9498-37c4a1d76071",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "services",
        iconImage: Services,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:17a0f713-e026-4f78-b011-965bcb60e81d",
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "dine",
    id: "dine",
    color: "183,68%,21%",
    icon: FaUtensils,
    items: [
      {
        title: "cafes",
        iconImage: Cafe,
        id: [
          "a59cce03-e052-4692-bf1d-64b0e9899422:4c0db85c-bc58-4c71-aac6-8f52016cd2bc",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "desserts",
        iconImage: Desserts,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:b3956059-f2a5-456b-8b9a-ea2022cc1b21",
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fast-food",
        iconImage: FastFood,
        id: [
          "a59cce03-e052-4692-bf1d-64b0e9899422:38f9e095-ef32-44d4-8f8b-58838a728d38",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "restaurants",
        iconImage: Restaurant,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:6ae84d79-f83e-4145-b8f4-3bcefc792af2",
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "leisure",
    id: "leisure",
    color: "207,19%,53%",
    icon: FaFaceSmile,
    items: [],
  },
  {
    title: "unwind-stay",
    id: "unwind-stay",
    color: "311,78%,20%",
    iconImage: Hotel,
    iconImageAlt: HotelWhite,
    listed: false,
    items: [
      {
        title: "kempinski",
        iconImage: HotelLight,
        id: [
          "0f9a8711-6459-4a28-a8ac-6a84c3c86e54:12f77321-5d4a-4ef3-8ac7-3d7366ce1453",
        ],
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "facilities",
    id: "facilities",
    color: "218,48%,22%",
    iconImage: Facilities,
    iconImageAlt: FacilitiesWhite,
    items: [
      {
        title: "female-prayer-room",
        iconImage: PrayerRoomFemale,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:16c8632d-fa14-4dfb-af87-19282ce6a57b",
        type: "list",
        hideIconUntilSelected: false,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "male-prayer-room",
        iconImage: PrayerRoomMale,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:87bb9abe-78ed-4416-9171-800aa049f0d8",
        type: "list",
        hideIconUntilSelected: false,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "female-toilet",
        iconImage: RestroomFemale,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:ebdcb2e7-a06d-49bf-851b-b91d1c526590",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        hideMapIcon: false,
      },
      {
        title: "male-toilet",
        iconImage: RestroomMale,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:90d1bf0c-68aa-4e36-8d14-306fa239cee0",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        hideMapIcon: false,
      },
      {
        title: "atm",
        iconImage: ATM,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:2bd735ca-029b-4734-bea2-2a0c65d2b5dc",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "customer-service-desk",
        iconImage: CustomerServiceDesk,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:3a62ffad-9be2-424d-a776-6454107ccafd",
        type: "closest",
        hideIconUntilSelected: false,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "baby-care-room",
        iconImage: BabyCare,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:2a263b30-9fdd-446b-a1de-b5b6e5023bb6",
        type: "closest",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "baby-changing-room-female",
        iconImage: BabyChangingFemale,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:ebdcb2e7-a06d-49bf-851b-b91d1c526590",
        type: "closest",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "baby-changing-room-male",
        iconImage: BabyChangingMale,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:90d1bf0c-68aa-4e36-8d14-306fa239cee0",
        type: "closest",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "female-accessible-toilet",
        iconImage: FemaleAccessibleToilet,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:ebdcb2e7-a06d-49bf-851b-b91d1c526590",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        hideMapIcon: false,
      },
      {
        title: "male-accessible-toilet",
        iconImage: MaleAccessibleToilet,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:90d1bf0c-68aa-4e36-8d14-306fa239cee0",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        hideMapIcon: false,
      },
      {
        title: "taxi-pickup",
        iconImage: Taxi,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:7cb1fa34-5959-4e20-be01-85fa3762db8a",
        type: "list",
        hideIconUntilSelected: false,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "otaxi",
        iconImage: UberCareem,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:10321662-6e0b-4efa-b1c5-4da53d8de20d",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "bus-stop",
        iconImage: Bus,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:75ee6030-7612-4e4c-a389-ac703dc8a341",
        type: "list",
        hideIconUntilSelected: false,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "entrance",
        iconImage: Entrance,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:5a7780ef-573d-42e6-9707-ad60e1ad28ac",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "valet-parking",
        iconImage: ValetParking,
        id: [
          "a59cce03-e052-4692-bf1d-64b0e9899422:38aa29d5-bc6c-4975-96f4-3510cb797a1f",
        ],
        type: "list",
        excludeFromSearch: false,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "vip-pickup-dropoff",
        iconImage: VipPickup,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:deb8a25d-c8a0-4f81-8fe5-70b3768365dd",
        type: "list",
        excludeFromSearch: true,
        hideIconUntilSelected: true,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "pod-parking",
        iconImage: AccessibleParking,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:4a007103-5ba7-4172-a6fb-6f26330a2a45",
        type: "list",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "family-parking",
        iconImage: FamilyParking,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:70971356-a266-4b35-a4db-79398a7e491a",
        type: "list",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "expectant-mother-parking",
        iconImage: ExpectantParking,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:8b804ea5-8def-43ee-aebb-738b523ac712",
        type: "list",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "electric-car-charging",
        iconImage: ElectricCarCharging,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:72f978fc-6788-48db-b95f-18962e99efcc",
        type: "list",
        hideIconUntilSelected: false,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "low-emission-parking",
        iconImage: LowEmissionParking,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:09d3d3a7-d71d-44cd-8b4c-4bc67f321842",
        type: "list",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "electric-scooter-station",
        iconImage: ElectricScooter,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:070dbfdc-36ff-4093-9b3c-42f0fa0eaa49",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "bike-parking",
        iconImage: BikeParking,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:f4cce8f9-8eb8-42b9-9e30-26d7c03dfee2",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "find-my-car-kiosk",
        iconImage: ParkingAssist,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:05a237e5-04cb-4a59-b6dd-f72d436158cd",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "charity",
        iconImage: RedCrescent,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:7fe4faa4-37a0-4828-9f0a-d0035952bfef",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "lost-found",
        iconImage: LostFound,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:4d5720a6-dd17-42e7-aecb-e671a1fcb4c7",
        type: "closest",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "first-aid-room",
        iconImage: FirstAid,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:4c4221a5-79ba-4580-8f76-44c8db8130ea",
        type: "closest",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "phone-charging",
        iconImage: PhoneCharging,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:3a62ffad-9be2-424d-a776-6454107ccafd",
        type: "closest",
        hideIconUntilSelected: false,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "wheelchairs",
        iconImage: Wheelchair,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:05ebb313-7c6c-4fce-b219-9b471fe6f2be",
        type: "closest",
        excludeFromSearch: true,
        hideIconUntilSelected: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "gift-card",
        iconImage: GiftCard,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:3a62ffad-9be2-424d-a776-6454107ccafd",
        type: "closest",
        hideIconUntilSelected: false,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "mall-management-office",
        iconImage: MallManager,
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:e1aada84-05a3-49d2-b5bc-5d4f3754d98a",
        type: "closest",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "parking-bays",
        id: [
          "a59cce03-e052-4692-bf1d-64b0e9899422:baa83f03-e674-4ab8-af8b-5015db518986",
          "a59cce03-e052-4692-bf1d-64b0e9899422:b18be9c1-7088-4622-8bd7-f5ead853a8a1",
          "a59cce03-e052-4692-bf1d-64b0e9899422:721c7afe-a74a-4631-b1b1-57a7cfe00855",
          "a59cce03-e052-4692-bf1d-64b0e9899422:976beb17-6f5c-493b-b2fd-21073cca8c33",
        ],
        type: "list",
        listed: false,
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "vacant",
        id: "a59cce03-e052-4692-bf1d-64b0e9899422:ba01babe-5864-46be-a7b8-877696c910ed",
        type: "list",
        listed: false,
        hideMapIcon: true,
        excludeFromSearch: true,
        hideIconUntilSelected: true,
        listAsClosest: false,
      },
      {
        title: "others",
        id: [
          "a59cce03-e052-4692-bf1d-64b0e9899422:5deb42ad-9e41-43cd-b93b-786b5957ae29",
        ],
        type: "list",
        listed: false,
        hideMapIcon: true,
        excludeFromSearch: false,
        hideIconUntilSelected: true,
        listAsClosest: false,
      },
      {
        title: "notlistedbuttobehide",
        id: [],
        type: "list",
        listed: false,
      },
      {
        title: "wifi",
        iconImage: Wifi,
        type: "info",
        listed: false,
        content: {
          en: `
						<h3 class="text-xl font-bold my-4">#Free_ Mall_WiFi</h3>
						<p class="font-bold mb-4">We Understand that staying connected is important in today’s world. That’s why we’re excited to offer #Free_ Mall_WiFi to all our shoppers.</p>
						<ul class="mb-4">
							<li>1. Please choose #Free_Mall_WiFi from the list of Wi-Fi networks.</li>
							<li>2. Your device should automatically be taken to our login page.</li>
							<li>3. Enter your details and follow the instructions to gain high-speed internet service.</li>
						</ul>
					`,
          ar: `
						<h3 class="text-xl font-bold my-4">#Free_ Mall_WiFi</h3>
						<p class="font-bold mb-4">نحن نتفهم أن البقاء على اتصال أمر مهم في عالم اليوم.لهذا السبب نحن متحمسون لتقديم خدمة فري وايفاي لجميع المتسوقين لدينا</p>
						<ul>
							<li>من قائمة الشبكات #Free_Mall_WiFi الرجاء اختيار</li>
							<li>يجب أن يتم نقل جهازك تلقائيا إلى صفحة تسجيل الدخول الخاصة بنا</li>
							<li>أدخل بياناتك واتبع التعليمات للحصول على خدمة إنترنت عالي السرعة</li>
						</ul>
					`,
        },
      },
      {
        title: "share",
        iconImage: Share,
        type: "info",
        listed: false,
        content: {
          en: `
						<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary mt-4 block text-lg font-semibold">Join SHARE</a>
						<h3 class="text-2xl font-bold mb-6">Get More At Mall of the Emirates</h3>
						<p class="mb-6">As a member of the SHARE rewards programme, you get cash back in points at all stores and restaurants in Mall of the Emirates and beyond. Join the SHARE programme now – it’s free and will only take you a few minutes.</p>
						<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary text-lg font-semibold">Join SHARE Rewards</a>
					`,
          ar: `
					<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary mt-4 block text-lg font-semibold">سجلوا في تطبيق شير</a>
					<h3 class="text-2xl font-bold mb-6">احصلوا على المزيد في مول الإمارات<h3>
					<p class="mb-6">تخولكم عضويتكم في برنامج المكافآت شير استرداد بعض النقود في صورة نقاط لدى جميع المتاجر والمطاعم في مول الإمارات وأماكن أخرى خارج المول. انضموا إلى برنامج المكافآت شير الآن - فهو مجاني ولا يلزم لانضمامكم إليه سوى دقائق معدودة.</p>
					<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary text-lg font-semibold">سجلوا في تطبيق شير</a>
					`,
        },
      },
    ],
  },
];

filterCategories.push({
  title: "hidden",
  id: "hidden",
  listed: false,
  items: [
    {
      title: "hidden",
      id: getHiddenUntilSelectedItems() as string[],
      type: "list",
      listed: false,
    },
  ],
});

export const kiosks: KioskModel[] = [
  {
    name: "kiosk",
    latitude: 25.21620020891565,
    longitude: 55.40792571152656,
    level: 0,
    pitch: 40,
    bearing: 10,
    zoom: 18,
    poiId:
      "75698d35-0918-4a2b-a8ab-77b93a618e61:c2f3d327-d2ee-4d6f-a14f-2a85dfb1ab8d",
  },
];

export const excludedAmenities: string[] = getExcludedItems() as string[];

// Function to build additional filters based on amenities and features
export const buildAdditionalFilters = ({
  amenities,
  features,
  language,
}: {
  amenities: AmenityModel[] | null;
  features: Feature[] | null;
  language: string;
}): FilterItemModel[] | void => {
  // Early exit if amenities or features are missing
  if (!amenities) {
    console.error("amenities is null");
    return;
  }

  if (!features) {
    console.error("features is null");
    return;
  }

  // Define amenity titles and their mapping to ids/features
  const amenityMapping: {
    [key: string]: {
      amenity?: AmenityModel;
      features: Feature[];
      icon: string;
    };
  } = {
    "Snow/Ski": { amenity: undefined, features: [], icon: Snow },
    "Vox Cinema": { amenity: undefined, features: [], icon: VoxCinema },
    "Magic Planet": { amenity: undefined, features: [], icon: MagicPlanet },
    iFLY: { amenity: undefined, features: [], icon: iFly },
    "Little Explorers": {
      amenity: undefined,
      features: [],
      icon: LittleExplorers,
    },
    Entertainment: { amenity: undefined, features: [], icon: Entertainment },
  };

  // Map amenities to their respective amenity titles
  for (const amenity of amenities) {
    if (amenityMapping[amenity.title]) {
      amenityMapping[amenity.title].amenity = amenity;
    }
  }

  // Map features to their respective amenities
  for (const feature of features) {
    for (const key in amenityMapping) {
      const { amenity } = amenityMapping[key];
      if (feature.properties?.amenity === amenity?.id) {
        amenityMapping[key].features.push(feature);
      }
    }
  }

  // Utility function to retrieve a translated title
  const getTranslatedTitle = (feature: Feature): string => {
    const { title_i18n, title } = feature.properties || {};
    return title_i18n?.[language] || title_i18n?.en || title;
  };

  const items: FilterItemModel[] = [];

  // Create filter items for each amenity based on available features
  for (const key in amenityMapping) {
    const { amenity, features, icon } = amenityMapping[key];

    if (amenity && features.length > 0) {
      let itemTitle: string | undefined;

      // If there is only one feature, use the feature title
      if (features.length === 1) {
        itemTitle = getTranslatedTitle(features[0]);
      }

      // Set up the item object for the filter list
      const baseItem: FilterItemModel = {
        title: key.toLowerCase().replace(/\s/g, "-"), // Convert title to kebab-case
        translatedTitle: itemTitle,
        iconImage: icon,
        id: [amenity.id],
        hideMapIcon: true,
        type: "list",
      };

      // Push items to the list based on the type (list or single)
      if (key === "Entertainment") {
        // For "Entertainment", push individual features
        features.forEach((feature) => {
          items.push({
            ...baseItem,
            type: "single",
            title: getTranslatedTitle(feature)
              .toLowerCase()
              .replace(/\s/g, "-"), // Convert title to kebab-case
            translatedTitle: getTranslatedTitle(feature),
            featureId: feature.id,
          });
        });
      } else {
        // For other amenities, push as a list
        items.push(baseItem);
      }
    }
  }

  const entertainmentIndex = filterCategories.findIndex(
    (category) => category.id === "leisure",
  );
  filterCategories[entertainmentIndex].items = items;
};
